import http from '@/common/request/axios';

export const translationService = {
    list({ offset, limit, locale, filterType, criteria }: any) {
        return http.doGet('admin/translation', { offset, limit, locale, filterType, criteria });
    },

    create(name: any) {
        return http.doPost('admin/translation', {
            name: name
        });
    },

    update(id: number, name: any) {
        return http.doPut('admin/translation/' + id, {
            name: name
        });
    },

    remove(id: number) {
        return http.doDelete('admin/translation/' + id);
    },

    get(id: number) {
        return http.doGet('admin/translation/' + id);
    },

    updateContent(id: number, locale: string, content: any) {
        return http.doPut('admin/translation/' + id + '/' + locale, {
            content: content
        });
    },

    getContent(id: number, locale: string) {
        return http.doGet('admin/translation/' + id + '/' + locale);
    },

    removeContent(id: number, locale: string) {
        return http.doDelete('admin/translation/' + id + '/' + locale);
    },

    export() {
        return http.doGet('admin/translation/export');
    },

    import(file: any) {
        return http.doPost(
            'admin/translation/import',
            {},
            {
                file: file
            }
        );
    }
};
